export enum DefinitionSpecialTypes {
	Area = "area",
	User = "user",
	Template = "template",
}

export default interface DataSourceItem {
	id:				string;
	fields:			any;
	label:			string;
	dataSourceId:	string;
}

export interface DataSource {
	id: string | null
	title: string
	folder: string
	definitionId: string | null
	itemCount: number
	includedLists: any[]
	editPermissions: string[]
}

export interface DataSourceSetupDetails extends DataSource {
	treeLayout: boolean

	createItemModalTitle?: string | null
	treeCreateItemModalTitle?: string | null
	treeItemSelectedModalTitle?: string | null

	searchResults?: any[]
	extraFields?: any[]

	getItems?: (() => Promise<any[]>) | null
	/**
	 * The save method to update the contents of the data source
	 */
	save?: ((item: any) => Promise<any>) | null
	itemDetails?: ((item: any) => Promise<any>) | null
	delete?: ((item: any) => Promise<void>) | null
}

export interface DataSourceItemSLA {
	id: string
	dataSourceId: string
	dataSourceItemId: string
	slaHours: number // float
}
